import { render } from "./_list.vue?vue&type=template&id=259b0188"
import script from "./_list.vue?vue&type=script&lang=js"
export * from "./_list.vue?vue&type=script&lang=js"

import "./_list.vue?vue&type=style&index=0&id=259b0188&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__